<template>
  <div class="video-container">
    <video
      ref="videoPlayer"
      playsinline
      controls
      :poster="poster"
      :src="src"
    ></video>
  </div>
</template>

<script>
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export default {
  name: "VideoPlayer",
  props: {
    src: { type: String, required: true },
    poster: { type: String, default: "" },
    /** @deprecated gunakan quizTimes; tetap didukung untuk 1 timestamp */
    quizTime: {
      type: Number,
      default: null,
    },
    /** Daftar detik unik kapan quiz muncul, contoh: [30, 80, 120] */
    quizTimes: {
      type: Array,
      default: () => [],
    },
    allowQuizTrigger: {
      type: Boolean,
      default: true,
    },
    isTeacher: { type: Boolean, default: false },
    isPrincipal: { type: Boolean, default: false },
  },
  data() {
    return {
      player: null,
      maxAllowedTime: 0,
      quizTriggeredTimes: new Set(),
      isSeeking: false,
    };
  },
  computed: {
    normalizedQuizTimes() {
      const fromArray = Array.isArray(this.quizTimes)
        ? this.quizTimes.map((t) => Number(t)).filter((t) => !Number.isNaN(t) && t >= 0)
        : [];
      if (fromArray.length) {
        return [...new Set(fromArray)].sort((a, b) => a - b);
      }
      if (this.quizTime != null && !Number.isNaN(Number(this.quizTime))) {
        return [Number(this.quizTime)];
      }
      return [];
    },
  },
  watch: {
    src() {
      this.resetPlaybackState();
    },
    quizTimes: {
      deep: true,
      handler() {
        // Jangan reset yang sudah ter-trigger; biarkan times baru ikut dicek
      },
    },
  },
  mounted() {
    this.player = new Plyr(this.$refs.videoPlayer, {
      controls: [
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
      ],
      seekTime: 10,
    });

    const isPrivileged = this.isTeacher || this.isPrincipal;
    if (!isPrivileged) {
      this.player.on("seeking", () => {
        if (this.player.currentTime > this.maxAllowedTime) {
          this.player.currentTime = this.maxAllowedTime;
        }
      });

      this.player.on("seeked", () => {
        if (this.player.currentTime > this.maxAllowedTime) {
          this.player.currentTime = this.maxAllowedTime;
        }
      });
    }

    this.player.on("ended", () => {
      this.$emit("video-ended");
    });

    this.player.on("timeupdate", () => {
      const currentTime = this.player.currentTime;

      if (!this.isTeacher && !this.isPrincipal) {
        if (currentTime > this.maxAllowedTime + 0.5) {
          this.player.currentTime = this.maxAllowedTime;
          return;
        }
      }

      if (!this.isTeacher && !this.isPrincipal) {
        if (currentTime > this.maxAllowedTime) {
          this.maxAllowedTime = currentTime;
        }
      }

      if (!this.allowQuizTrigger || !this.normalizedQuizTimes.length) return;

      const currentSec = Math.floor(currentTime);
      // Ambil timestamp paling awal yang sudah lewat & belum pernah di-trigger
      const dueTime = this.normalizedQuizTimes.find(
        (t) => currentSec >= t && !this.quizTriggeredTimes.has(t)
      );

      if (dueTime == null) return;

      this.quizTriggeredTimes.add(dueTime);
      this.player.pause();
      this.$emit("quiz-trigger", dueTime);
    });
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    resetPlaybackState() {
      this.maxAllowedTime = 0;
      this.quizTriggeredTimes = new Set();
    },
  },
};
</script>
<style scoped>
.video-container {
  width: 100%;
  max-width: 100%;
}

video {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  background: black;
}
</style>
